import { Section } from "@/components/layout/section";

const STEPS = [
  {
    title: "Daftar & Pasang Area",
    description: "Buat akun dan tentukan lingkungan yang ingin Anda awasi — rumah, gang, atau komplek.",
  },
  {
    title: "Pantau & Laporkan",
    description: "Warga dapat melaporkan insiden dalam satu ketukan; petugas menerima peringatan langsung.",
  },
  {
    title: "Tindak Cepat",
    description: "Koordinasi patroli dan eskalasi ke layanan darurat bila diperlukan, tercatat rapi.",
  },
];

export function HowItWorks() {
  return (
    <Section id="cara-kerja" className="bg-surface-2">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold sm:text-4xl">Cara Kerja</h2>
        <p className="mt-4 text-text-muted">
          Tiga langkah sederhana untuk membawa keamanan malam ke level berikutnya.
        </p>
      </div>

      <ol className="mt-12 grid gap-8 sm:grid-cols-3">
        {STEPS.map((step, index) => (
          <li key={step.title} className="relative">
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent font-display text-lg font-bold text-accent-foreground">
              {index + 1}
            </span>
            <h3 className="mt-4 text-lg font-semibold">{step.title}</h3>
            <p className="mt-2 text-sm text-text-muted">{step.description}</p>
          </li>
        ))}
      </ol>
    </Section>
  );
}
